import { createAction } from '@reduxjs/toolkit';

/**
 * Ask which of `engineIds` this environment has. Answered from localStorage
 * when the cache is fresh, otherwise from the API — the saga decides, so
 * callers dispatch this either way.
 */
export const CHECK_ENGINE_AVAILABILITY = createAction<{
  engineIds: readonly string[];
}>('vtn/redact/engine/availability/CHECK_ENGINE_AVAILABILITY');

export const CHECK_ENGINE_AVAILABILITY_SUCCESS = createAction<{
  availableIds: readonly string[];
}>('vtn/redact/engine/availability/CHECK_ENGINE_AVAILABILITY_SUCCESS');

/**
 * Carries no ids on purpose. A failed check leaves `availableIds` null, which
 * every caller reads as "offer everything" — the API being unreachable is not
 * evidence that an engine is missing, and the cost of guessing wrong in this
 * direction is a job that fails rather than a feature that disappears.
 */
export const CHECK_ENGINE_AVAILABILITY_FAILURE = createAction<{
  error: unknown;
}>('vtn/redact/engine/availability/CHECK_ENGINE_AVAILABILITY_FAILURE');
